import React from 'react';
import { customInspectionTypeSettings } from '../../../../common/src/domain/customInspectionTypes/customInspectionTypeSettings';
import { customInspectionTypeFrontEndSettings } from '../../customInspectionTypes/customInspectionTypeFrontEndSettings';
import { useTranslate } from '../../mixins/translate/translate';
import { InspectionStandardTypes } from '../../utils/enums/InspectionStandardTypes';
import { ConditionScoreLabel } from '../utils/ConditionScoreLabel';

function FormatConditionComponent(props: {
    condition?: undefined | string;
    careCondition?: undefined | string;
    inspectionStandardType?: InspectionStandardTypes | undefined | null | string;
}) {
    const translate = useTranslate();
    if (props === undefined) {
        return null;
    }
    if (!props.inspectionStandardType) {
        return null;
    }
    const commonSettings = customInspectionTypeSettings[props.inspectionStandardType];
    if (commonSettings && commonSettings.conditionScoreToText) {
        const colorCode = commonSettings.conditionScoreToColorCode(props.condition);
        const text = commonSettings.conditionScoreToText(props.condition, translate);

        return (
            <span className="label p5 fs11" style={{ backgroundColor: colorCode }}>
                {text}
            </span>
        );
    }
    const settings = customInspectionTypeFrontEndSettings[props.inspectionStandardType];
    if (settings && settings.getConditionLabel) {
        // eslint-disable-next-line @typescript-eslint/unbound-method, @typescript-eslint/naming-convention
        const Label = settings.getConditionLabel;
        return <Label conditionScore={props.condition} />;
    }
    if (props.inspectionStandardType === InspectionStandardTypes.Model3d) {
        return null;
    }
    if (props.condition && props.careCondition) {
        return (
            <>
                {' '}
                <ConditionScoreLabel value={props.condition} />
                &nbsp;/&nbsp;
                <ConditionScoreLabel value={props.careCondition} />
            </>
        );
    } else if (props.condition !== 'U') {
        return <ConditionScoreLabel value={props.condition} />;
    }
    return null;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const FormatCondition = React.memo(FormatConditionComponent);
